type AuthDataType = {
  auth: string
  email: string
  userName: string
  userId: string
  companyName: string
}

const localStorageAuthKey = [
  'auth',
  'email',
  'userName',
  'userId',
  'companyName',
]

export const LOGIN_URL_WITH_REDIRECT = `${process.env.REACT_APP_AUTH_URL}/api/logout?redirectUri=${window.location.origin}/invoices`

export const redirectAuth = (): void => {
  window.location.href = LOGIN_URL_WITH_REDIRECT
}

export const clearAuth = (): void => {
  localStorageAuthKey.forEach((item) => localStorage.removeItem(item))
}

export const logOut = (): void => {
  clearAuth()
  redirectAuth()
}

// eslint-disable-next-line consistent-return
export const getAuthData = (): AuthDataType => {
  const dataFormatted = localStorageAuthKey.reduce((accum, curr): any => {
    return {
      ...accum,
      [curr]: localStorage.getItem(curr),
    }
  }, {})
  return dataFormatted
}
